import script from "./CompanyForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyForm.vue?vue&type=script&lang=ts&setup=true"

import "./CompanyForm.vue?vue&type=style&index=0&id=57d62f8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57d62f8c"]])

export default __exports__